import { render, staticRenderFns } from "./Police_Stations.vue?vue&type=template&id=29a0e1af&scoped=true&"
import script from "./Police_Stations.vue?vue&type=script&lang=js&"
export * from "./Police_Stations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a0e1af",
  null
  
)

export default component.exports